import styled from "styled-components";

export const OptInAccordionTitleCasino777Box = styled.div`
    font-size: 1.5rem;
    font-weight: bold;
    padding: 12px;
    color: ${props => props.theme.colors.backgroundActive};
`;
